// zafra Kundenstimmen: einfache Rotation, alle 8 Sekunden oder per Pfeil, pausiert bei Hover.

document.querySelectorAll('[data-testimonials]').forEach((root) => {
  const items = Array.from(root.querySelectorAll('[data-testimonial]'));
  if (items.length < 2) return;
  const prev = root.querySelector('[data-testimonial-prev]');
  const next = root.querySelector('[data-testimonial-next]');
  const count = root.querySelector('[data-testimonial-count]');
  let index = 0;
  let timer;

  const show = (i) => {
    index = (i + items.length) % items.length;
    items.forEach((el, n) => el.classList.toggle('is-active', n === index));
    if (count) count.textContent = `${index + 1} / ${items.length}`;
  };

  const start = () => {
    stop();
    timer = window.setInterval(() => show(index + 1), 8000);
  };
  const stop = () => window.clearInterval(timer);

  if (prev) prev.addEventListener('click', () => { show(index - 1); start(); });
  if (next) next.addEventListener('click', () => { show(index + 1); start(); });
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
});
